angular.module('FlexyBeautyApp.services')
    .factory('KycDocumentStatus', ['gettextCatalog', function (gettextCatalog) {
        return {
            VALIDATION_ASKED:
                {
                    id: 'VALIDATION_ASKED',
                    label: gettextCatalog.getString("En cours")
                },
            VALIDATED:
                {
                    id: 'VALIDATED',
                    label: gettextCatalog.getString("Document validé")
                },
            REFUSED:
                {
                    id: 'REFUSED',
                    label: gettextCatalog.getString("Document refusé")
                }
        };
    }]);



// WEBPACK FOOTER //
// ./js/services/views/KycDocumentStatus.js